import { render, staticRenderFns } from "./textDetail.vue?vue&type=template&id=2f269f80"
import script from "./textDetail.vue?vue&type=script&lang=js"
export * from "./textDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports